import script from "./CreateCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCustomer.vue?vue&type=script&setup=true&lang=js"

import "./CreateCustomer.vue?vue&type=style&index=0&id=87def388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87def388"]])

export default __exports__